import React, { useEffect, useRef, useState } from 'react';
// import { productList } from '../../../Common/data';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import DeleteModal from '../../../Common/modals/DeleteModal';
import CustomTable from '../../../Components/CustomTable/CustomTable';
import { useDeleteProductMutation, useGetProductsListQuery } from '../../../Redux/ProductSlice';
import useDebounce from '../../../hooks/useDebounce';
import TableLoader from './TableLoader';

const ProductTable = ({ data, handleCheckboxChange, selectedRows, mincost, maxcost, selectedCategry, selectedSizes, selectedColors, limit, page, setPage, setlimit, search, setSearch }) => {

  const inputRef = useRef(null);


  const debounceSearch = useDebounce(search, 300)


  const handleClearSearch = () => {
    setSearch('');
    if (inputRef.current) {
      inputRef.current.value = ''; // Clear the input field visually
    }
  };





  const [showModal, setShowModal] = useState(false);
  const [deleteCategoryFn, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: deleteSuccess }] = useDeleteProductMutation();
  const [deleteItem, setDeleteItem] = useState({});


  const queryParams = [];
  if (page) {
    queryParams.push({ name: 'page', value: page })
  }
  if (limit) {
    queryParams.push({ name: 'limit', value: limit })
  }
  if (debounceSearch) {
    queryParams.push({ name: 'search', value: debounceSearch })
  }
  if (mincost) {
    queryParams.push({ name: 'fromPrice', value: mincost })
  }
  if (maxcost) {
    queryParams.push({ name: 'toPrice', value: maxcost })
  }


  if (selectedCategry?.length > 0) {
    queryParams.push({ name: 'categoryId', value: JSON.stringify(selectedCategry) })
  }
  if (selectedColors?.length > 0) {
    queryParams.push({ name: 'colourId', value: JSON.stringify(selectedColors) })
  }

  if (selectedSizes?.length > 0) {
    queryParams.push({ name: 'sizeId', value: JSON.stringify(selectedSizes) })
  }

  const { data: productList, isSuccess, error, isFetching: productListFetching } = useGetProductsListQuery(queryParams);
  // useEffect(() => {
  //   // productListFn(getQueryString({ page: 1, limit: 5, search: debounceSearch }))

  //   // for (const key in object) {
  //   //   if (Object.hasOwnProperty.call(object, key)) {
  //   //     const element = object[key];

  //   //   }
  //   // }

  //   let queryObject = {}


  //   // if (selectedCategry?.length > 0) {
  //   //   queryObject = { ...queryObject, categoryId: JSON.stringify(selectedCategry) }
  //   // }
  //   // if (selectedColors?.length > 0) {
  //   //   queryObject = { ...queryObject, colourId: JSON.stringify(selectedColors) }
  //   // }

  //   // if (selectedSizes?.length > 0) {
  //   //   queryObject = { ...queryObject, sizeId: JSON.stringify(selectedSizes) }
  //   // }




  //   // productListFn(getQueryString({ page, limit, search: debounceSearch, fromPrice: mincost, toPrice: maxcost, ...queryObject }))

  // }, [debounceSearch, mincost, maxcost, selectedCategry, selectedColors, selectedSizes, page, limit]);

  useEffect(() => {
    // deleteData, error: deleteErr, isLoading: deleteLoading,deleteSuccess
    if (deleteSuccess) {
      setShowModal(false)
      const message = deleteData?.message || "Delete successfully";
      toast.success(message);
      setDeleteItem({})
      // productListFn()

      // productListFn(getQueryString({ page: 1, limit: 100, search: debounceSearch }))

    }
    if (deleteErr) {
      if ('data' in deleteErr) {
        const errorData = deleteErr;
        toast.error(errorData.data.message);

      }
    }
  }, [deleteData, deleteSuccess, deleteErr]);

  const customTablecolumns = [


    {
      Header: "Product name",
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => (
        <>
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <div className="avatar-sm bg-light rounded p-1 d-flex justify-content-center">
                <img
                  src={cellProps?.productListImageViews?.[0]?.productListImage?.url || cellProps?.ProductImageColourCombinations?.[0]?.image?.[0]?.preview}
                  alt=""
                  className="img-fluid d-block avatar-xs mt-1"
                />
              </div>
            </div>
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-1">
                <Link
                  to={`/product-edit/${cellProps?.id}`}
                  className="d-block text-reset"
                >
                  {" "}
                  {cellProps.productTitle}
                </Link>
              </h5>
              <p className="text-muted mb-0">
                Category :{" "}
                <span className="fw-medium">

                  {cellProps?.ProductCategoryCombinations?.reduce((elem, current) => `${elem + current?.Category?.name ?? ''},`, '')}
                </span>
              </p>
            </div>
          </div>
        </>
      ),
    },
    {
      Header: "Stock",

      fieldName: 'productTitle',
      CustomDesign: (cellProps) => cellProps?.ProductSizeColourCombinations?.reduce((acc, cur) => acc + Number(cur?.quantity), 0)
    },
    {
      Header: "Size",
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => {
        return (
          <div className="d-flex" >
            <div >{cellProps?.ProductSizeCombinations?.map((item, index) =>
              <span className="badge py-2 px-2 bg-light rounded-circle text-info fs-13 fw-medium me-1" style={{ width: "30px", height: "30px" }}>{item?.Size?.name}</span>
            )}</div>
          </div>
        )
      }
    }, {
      Header: "Colour",
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => {
        return (
          <>

            <div className="avatar-group">
              {
                cellProps?.ProductColourCombinations?.map(color =>
                  <div className="avatar-item" style={{ backgroundColor: color?.ProductColour?.hexCode, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span className="avatar-text"></span>
                  </div>)
              }

            </div>

          </ >
        )
      }
    },
    {
      Header: "Price",

      fieldName: 'sellingPrice'

    },
    {
      Header: "Orders",
      fieldName: 'orders',

    },
    {
      Header: "Action",
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => {
        return (
          <span>
            <ul className="hstack gap-2 list-unstyled mb-0">
              <li>
                <Link to={`/product-edit/${cellProps?.id}`} className="badge bg-info-subtle text-info" >Edit</Link>
              </li>
              <li>
                <Link to="#" className="badge bg-danger-subtle text-danger" onClick={() => {
                  setDeleteItem({ ...cellProps, name: cellProps?.productTitle })
                  setShowModal(true)
                }}>Delete</Link>
              </li>
            </ul>
          </span>
        );
      },
    }

  ]





  return (
    <React.Fragment>
      <Row className="g-4 mb-4">
        <Col className="col-sm-auto">
          <div>
            <Link to="/product-create" className="btn btn-success" id="addproduct-btn"><i className="ri-add-line align-bottom me-1"></i> Add Product</Link>


          </div>
        </Col>
        <Col className="col-sm">
          <div className="d-flex justify-content-sm-end">
            <div className="search-box ms-2">
              <Form.Control type="text" id="searchInputList" value={search} ref={inputRef} placeholder="Search products..." onChange={(e) => {

                setPage(1)

                setSearch(e.target.value)
              }} />
              <i className="ri-search-line search-icon"></i>
              <i className="ri-close-circle-line Cross-icon" onClick={handleClearSearch}></i>
            </div>
          </div>
        </Col>
      </Row>
      <div>
        {
          productListFetching ?
            <TableLoader /> :




            <CustomTable
              limit={limit} setlimit={setlimit}

              key="Product List" columns={customTablecolumns} rowsData={productList?.response || []} page={page} setPage={setPage}

              metaData={productList?.additional}
            />
        }
        {/* <TableContainer
          columns={columns}
          data={(productList?.response || [])}
        
          isAddUserList={false}
          customPageSize={5}
          tableClass="gridjs-table"
          theadClass="gridjs-th"
          isProductsFilter={true}
          SearchPlaceholder='Search Products...'
        /> */}
      </div>

      <DeleteModal showModal={showModal}
        setShowModal={setShowModal}
        data={deleteItem}
        handleSubmit={() => deleteCategoryFn({ id: deleteItem?.id })} />

    </React.Fragment>
  );
};

export default ProductTable;
